import React, { useEffect } from "react";
import classes from "./aboutPage.module.css";
import CustomLink from "../../components/CustomLink";
import bieuDoGPA from "../../static/img/bieu-do-gpa-theo-hoc-ky.png";
import giaoDienTinhDiem from "../../static/img/giao-dien-tinh-diem-gpa-cpa.png";
import importDiemPTIT from "../../static/img/import-diem-ptit.png";
import datMucTieu from "../../static/img/dat-muc-tieu-hoc-tap.png";
import chuyenDoiDiem from "../../static/img/chuyen-doi-diem-he-4.png";
import tinhDiemTongKet from "../../static/img/tinh-diem-tong-ket-mon.png";
import danhSachMonHoc from "../../static/img/danh-sach-mon-hoc-on-tap.png";
import giaoDienOnLuyen from "../../static/img/giao-dien-on-luyen.png";
import { FaGraduationCap } from "@react-icons/all-files/fa/FaGraduationCap";
import { AiOutlineCalculator } from "@react-icons/all-files/ai/AiOutlineCalculator";
import { SiConvertio } from "@react-icons/all-files/si/SiConvertio";
import { MdSchool } from "@react-icons/all-files/md/MdSchool";
import { FaTrophy } from "@react-icons/all-files/fa/FaTrophy";
import { BsQuestionCircle } from "@react-icons/all-files/bs/BsQuestionCircle";
import { FaRegBookmark } from "@react-icons/all-files/fa/FaRegBookmark";
import { FaRocket } from "@react-icons/all-files/fa/FaRocket";

function AboutPage() {
  useEffect(() => {
    document.title = "Grade PTIT | Giới thiệu - Công cụ quản lý điểm";
  }, []);

  return (
    <div className={classes.root}>
      {/* Hero Section */}
      <div className={classes.heroSection}>
        <div className={classes.heroContent}>
          <div className={classes.heroText}>
            <FaGraduationCap className={classes.heroIcon} />
            <h1 className={classes.heroTitle}>Grade PTIT</h1>
            <p className={classes.heroDescription}>
              Công cụ tính toán và quản lý điểm số hiện đại cho sinh viên Việt
              Nam. Hỗ trợ tính GPA, CPA và ước lượng cải thiện điểm một cách
              chính xác và nhanh chóng.
            </p>
            <div className={classes.heroStats}>
              <div className={classes.statItem}>
                <MdSchool className={classes.statIcon} />
                <span className={classes.statNumber}>10K+</span>
                <span className={classes.statLabel}>Sinh viên</span>
              </div>
              <div className={classes.statItem}>
                <AiOutlineCalculator className={classes.statIcon} />
                <span className={classes.statNumber}>5+</span>
                <span className={classes.statLabel}>Công cụ</span>
              </div>
              <div className={classes.statItem}>
                <FaTrophy className={classes.statIcon} />
                <span className={classes.statNumber}>100%</span>
                <span className={classes.statLabel}>Miễn phí</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.contentContainer}>
        {/* About Section */}
        <div className={classes.aboutSection}>
          <div className={classes.sectionHeader}>
            <FaRocket className={classes.sectionIcon} />
            <h2 className={classes.sectionTitle}>Về Grade PTIT</h2>
            <p className={classes.sectionDescription}>
              Nền tảng học tập thông minh dành riêng cho sinh viên
            </p>
          </div>
          <div className={classes.aboutContent}>
            <p className={classes.aboutText}>
              <strong>Grade PTIT</strong> được phát triển với sứ mệnh hỗ trợ
              sinh viên Việt Nam trong việc quản lý và tối ưu hóa kết quả học
              tập. Chúng tôi cung cấp các công cụ tính toán điểm số chính xác,
              ước lượng GPA/CPA và lên kế hoạch học tập hiệu quả.
            </p>
            <div className={classes.contactInfo}>
              <p>Liên hệ với chúng tôi để được hỗ trợ:</p>
              <div className={classes.contactLinks}>
                <a
                  href={"https://www.facebook.com/gradeptit"}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  className={classes.contactLink}
                >
                  Facebook Page Grade Ptit
                </a>
                <a
                  href={
                    "mailto:gradeptit@gmail.com?subject=Feedback to Gradeptit"
                  }
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  className={classes.contactLink}
                >
                  gradeptit@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Features Section */}
        <div className={classes.featuresSection}>
          <div className={classes.sectionHeader}>
            <FaRegBookmark className={classes.sectionIcon} />
            <h2 className={classes.sectionTitle}>Tính năng chính</h2>
            <p className={classes.sectionDescription}>
              Bộ công cụ toàn diện cho việc quản lý điểm số
            </p>
          </div>
          <div className={classes.featuresList}>
            <div className={classes.featureItem}>
              <div className={classes.featureIcon}>
                <FaGraduationCap />
              </div>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>
                  Tính GPA, CPA & Ước lượng điểm
                </h3>
                <p className={classes.featureDescription}>
                  Công cụ toàn diện giúp tính toán điểm trung bình học kỳ, tích
                  lũy và ước lượng cải thiện điểm. Hỗ trợ đặt mục tiêu học tập
                  và hiển thị biểu đồ trực quan theo dõi tiến độ qua các kỳ.
                </p>
                <CustomLink
                  to={"/gpa-cpa-learning-plan"}
                  className={classes.featureLink}
                >
                  Khám phá ngay →
                </CustomLink>
                <div className={classes.featureImages}>
                  <div className={classes.imageContainer}>
                    <img src={bieuDoGPA} alt="Biểu đồ GPA CPA theo học kỳ - Theo dõi tiến độ học tập" loading="lazy" />
                    <span className={classes.imageLabel}>
                      Biểu đồ điểm trực quan
                    </span>
                  </div>
                  <div className={classes.imageContainer}>
                    <img src={giaoDienTinhDiem} alt="Giao diện tính điểm GPA CPA Grade PTIT" loading="lazy" />
                    <span className={classes.imageLabel}>
                      Giao diện thân thiện
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.featureItem}>
              <div className={classes.featureIcon}>
                <FaTrophy />
              </div>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>Đặt mục tiêu học tập</h3>
                <p className={classes.featureDescription}>
                  Thiết lập mục tiêu bằng cấp Giỏi, Khá, Xuất sắc và tính toán
                  điểm cải thiện cần đạt để hoàn thành mục tiêu. Lập kế hoạch
                  học tập thông minh và có định hướng.
                </p>
                <CustomLink to={"/file-view"} className={classes.featureLink}>
                  Bắt đầu lên kế hoạch →
                </CustomLink>
                <div className={classes.featureImages}>
                  <div className={classes.imageContainer}>
                    <img src={datMucTieu} alt="Đặt mục tiêu học tập và tính điểm cần đạt" loading="lazy" />
                    <span className={classes.imageLabel}>
                      Đặt mục tiêu thông minh
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.featureItem}>
              <div className={classes.featureIcon}>
                <AiOutlineCalculator />
              </div>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>Tính điểm tổng kết</h3>
                <p className={classes.featureDescription}>
                  Tính toán điểm tổng kết chính xác dựa trên điểm thành phần và
                  cấu trúc điểm của từng môn học. Hỗ trợ nhiều loại cấu trúc
                  điểm khác nhau.
                </p>
                <CustomLink to={"/calc-point"} className={classes.featureLink}>
                  Tính điểm ngay →
                </CustomLink>
                <div className={classes.featureImages}>
                  <div className={classes.imageContainer}>
                    <img
                      src={tinhDiemTongKet}
                      alt="Tính điểm tổng kết môn học đại học"
                    />
                    <span className={classes.imageLabel}>
                      Tính điểm tổng kết dễ dàng
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.featureItem}>
              <div className={classes.featureIcon}>
                <SiConvertio />
              </div>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>
                  Chuyển đổi điểm hệ 10 sang 4
                </h3>
                <p className={classes.featureDescription}>
                  Quy đổi điểm số chính xác từ thang 10 sang thang 4 với nhiều
                  cấu trúc thang điểm khác nhau, phù hợp với tiêu chuẩn của các
                  trường đại học Việt Nam.
                </p>
                <CustomLink
                  to={"/convert-10-to-4"}
                  className={classes.featureLink}
                >
                  Chuyển đổi ngay →
                </CustomLink>
                <div className={classes.featureImages}>
                  <div className={classes.imageContainer}>
                    <img
                      src={chuyenDoiDiem}
                      alt="Chuyển đổi điểm từ hệ 10 sang hệ 4"
                    />
                    <span className={classes.imageLabel}>
                      Quy đổi điểm chính xác
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.featureItem}>
              <div className={classes.featureIcon}>
                <MdSchool />
              </div>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>
                  Hỗ trợ chuyên biệt cho PTIT
                </h3>
                <p className={classes.featureDescription}>
                  Tính năng đặc biệt dành cho sinh viên PTIT với dữ liệu học kỳ,
                  ngành học được cập nhật đầy đủ. Hỗ trợ import điểm từ file
                  Excel của hệ thống quản lý đào tạo.
                </p>
                <CustomLink to={"/file-view"} className={classes.featureLink}>
                  Dành cho sinh viên PTIT →
                </CustomLink>
                <div className={classes.featureImages}>
                  <div className={classes.imageContainer}>
                    <img src={importDiemPTIT} alt="Import điểm tự động từ PTIT Portal" loading="lazy" />
                    <span className={classes.imageLabel}>
                      Import điểm tự động
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.featureItem}>
              <div className={classes.featureIcon}>
                <BsQuestionCircle />
              </div>
              <div className={classes.featureContent}>
                <h3 className={classes.featureTitle}>Ôn thi trắc nghiệm</h3>
                <p className={classes.featureDescription}>
                  Hệ thống ôn tập trắc nghiệm với ngân hàng câu hỏi phong phú,
                  được cập nhật thường xuyên. Giao diện thân thiện, phù hợp cho
                  việc học tập của sinh viên.
                </p>
                <CustomLink to={"/find-file"} className={classes.featureLink}>
                  Bắt đầu ôn tập →
                </CustomLink>
                <div className={classes.featureImages}>
                  <div className={classes.imageContainer}>
                    <img src={danhSachMonHoc} alt="Danh sách môn học ôn tập trắc nghiệm" loading="lazy" />
                    <span className={classes.imageLabel}>Môn học đa dạng</span>
                  </div>
                  <div className={classes.imageContainer}>
                    <img src={giaoDienOnLuyen} alt="Giao diện ôn luyện trắc nghiệm hiện đại" loading="lazy" />
                    <span className={classes.imageLabel}>
                      Giao diện hiện đại
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Updates Section */}
        <div className={classes.updatesSection}>
          <div className={classes.sectionHeader}>
            <FaRocket className={classes.sectionIcon} />
            <h2 className={classes.sectionTitle}>Cập nhật gần đây</h2>
            <p className={classes.sectionDescription}>
              Những tính năng và cải tiến mới nhất
            </p>
          </div>
          <div className={classes.updatesList}>
            <div className={classes.updateItem}>
              <div className={classes.updateDate}>1/6/2024</div>
              <div className={classes.updateContent}>
                <h4>Tính GPA/CPA không cần đăng nhập</h4>
                <p>
                  Bổ sung tính năng mới cho phép tất cả sinh viên các trường đại
                  học sử dụng công cụ tính GPA/CPA mà không cần tạo tài khoản.
                </p>
                <CustomLink
                  to={"/gpa-cpa-learning-plan"}
                  className={classes.updateLink}
                >
                  Khám phá ngay →
                </CustomLink>
              </div>
            </div>
            <div className={classes.updateItem}>
              <div className={classes.updateDate}>14/5/2024</div>
              <div className={classes.updateContent}>
                <h4>Chuyển đổi điểm hệ 10 sang hệ 4</h4>
                <p>
                  Ra mắt công cụ quy đổi điểm với giao diện hiện đại, hỗ trợ
                  nhiều thang điểm khác nhau của các trường đại học Việt Nam.
                </p>
                <CustomLink
                  to={"/convert-10-to-4"}
                  className={classes.updateLink}
                >
                  Sử dụng ngay →
                </CustomLink>
              </div>
            </div>
            <div className={classes.updateItem}>
              <div className={classes.updateDate}>6/5/2024</div>
              <div className={classes.updateContent}>
                <h4>Ra mắt App Mobile</h4>
                <p>
                  Grade PTIT - Quản lý điểm với giao diện mới, tốc độ nhanh hơn
                  và tích hợp ôn thi trắc nghiệm. Hỗ trợ đầy đủ dữ liệu khóa
                  D23.
                </p>
                <CustomLink
                  to={
                    "https://play.google.com/store/apps/details?id=com.ducju.gradeptit"
                  }
                  className={classes.updateLink}
                >
                  Tải ứng dụng →
                </CustomLink>
              </div>
            </div>
          </div>
        </div>
        {/* Closing Section */}
        <div className={classes.closingSection}>
          <div className={classes.closingContent}>
            <h3 className={classes.closingTitle}>
              Cảm ơn bạn đã tin tưởng và sử dụng Grade PTIT
            </h3>
            <p className={classes.closingText}>
              Chúng tôi luôn nỗ lực không ngừng để mang đến trải nghiệm học tập
              tốt nhất. Hãy cùng Grade PTIT xây dựng tương lai học tập thông
              minh hơn!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
